import { create } from "zustand";

/**
 * VAŽNO: Stavke računa NISU ovde. One žive na serveru (nacrt
 * FiscalDocument-a), da bi POS ekran mogao da se osloni na backend kao
 * jedini izvor istine za obračun (vidi zahtev "obračun na backendu
 * mora biti autoritativan"). Ovaj store drži samo prolazno UI stanje
 * ekrana kase.
 */
interface PosStoreState {
  activeDocumentId: string | null;
  searchTerm: string;
  activeCategoryId: string | null;
  isCheckoutOpen: boolean;
  setActiveDocumentId: (id: string | null) => void;
  setSearchTerm: (term: string) => void;
  setActiveCategoryId: (id: string | null) => void;
  openCheckout: () => void;
  closeCheckout: () => void;
}

export const usePosStore = create<PosStoreState>((set) => ({
  activeDocumentId: null,
  searchTerm: "",
  activeCategoryId: null,
  isCheckoutOpen: false,
  setActiveDocumentId: (id) => set({ activeDocumentId: id }),
  setSearchTerm: (term) => set({ searchTerm: term }),
  setActiveCategoryId: (id) => set({ activeCategoryId: id }),
  openCheckout: () => set({ isCheckoutOpen: true }),
  closeCheckout: () => set({ isCheckoutOpen: false }),
}));
